export function formatNumber(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
  return n.toString();
}

export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  const s = Math.round(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  return `${d}d ago`;
}

export function timeUntil(iso: string | null | undefined): string {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  const diff = then - Date.now();
  if (diff <= 0) return 'due';
  const s = Math.round(diff / 1000);
  if (s < 60) return `in ${s}s`;
  const m = Math.round(s / 60);
  if (m < 60) return `in ${m}m`;
  const h = Math.round(m / 60);
  if (h < 24) return `in ${h}h`;
  const d = Math.round(h / 24);
  return `in ${d}d`;
}

export function slugify(v: string): string {
  return v.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 80);
}

export function formatCategoryPlural(cat: string): string {
  if (!cat) return '';
  const trimmed = cat.trim();
  const lower = trimmed.toLowerCase();
  
  // Uncountable / Already Plural categories that must NOT get an 's' appended
  if (
    lower.includes('real estate') ||
    lower.includes('healthcare') ||
    lower.includes('automotive') ||
    lower.includes('beauty') ||
    lower.includes('tech support') ||
    lower.includes('services') ||
    lower.endsWith('shops') ||
    lower.endsWith('studios') ||
    lower.endsWith('consultants') ||
    lower.endsWith('dealers') ||
    lower.endsWith('movers') ||
    lower.endsWith('schools')
  ) {
    return trimmed;
  }

  if (lower.endsWith('y') && !lower.endsWith('ey') && !lower.endsWith('ay')) {
    return `${trimmed.slice(0, -1)}ies`;
  }
  if (lower.endsWith('sh') || lower.endsWith('ch') || lower.endsWith('ss') || lower.endsWith('x') || lower.endsWith('z')) {
    return `${trimmed}es`;
  }
  if (lower.endsWith('s')) {
    return trimmed;
  }
  return `${trimmed}s`;
}
